import {Injectable} from '@angular/core';
import * as storeActions from '@catcore/actions/features';
import {FeatureType, FeatureTypeCreateInfo} from '@catcore/services/feature-type/feature-type';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {extractDataFromProperty} from '@catcore/utils';
import {Resource} from '@catfeatures/types';
import {EvidFunction} from '@catmodules/models/evid-functions/types';
import {FeatureEvidFunction} from '@catmodules/models/feature-evid-functions/types';
import {Store} from '@ngrx/store';
import {Restangular} from 'ngx-restangular';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class EvidFunctionsService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('evid-functions', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/evid-functions/services/evid-functions.service.ts